

import { axiosInstance } from "@/services/axiosInstance";

export const InvoiceResource = {
  getLista: parametros => {
    return axiosInstance.get("v1/invoice/", {
      params: parametros
    });
  },

  getListaInvoicePayment: parametros => {
     return axiosInstance.get("v1/invoice/invoicepayments", 
     { 
       params : parametros
     
     });
     
  },

  getById: parametros => {
    return axiosInstance.get("v1/invoice/:id", {
      urlParams: parametros
    });
  },

  register: (parametros) => {
    return axiosInstance.post('v1/invoice',
      parametros
    )
  },

  update: (parametros) => {
    return axiosInstance.put('v1/invoice',
      parametros
    )
  },


};